/* eslint-disable pii/no-phone-number */

import { Payload } from '../payload.model';
import { ZenitList, Section, ZenitEventName, ZenitPageType, ZenitPersonalizationParam, ZenitZoomLevel, ZenitUniverse } from '../zenit-general.model';

import { BasicEvent } from './basic-event.model';
import { ZenitExperiments } from './page-hit-event.model';

/**
 * Version of the Click event
 */
type Version = '2';

export interface ClickEvent extends BasicEvent {
    /** Type of the event. Must be Click */
    eventName: ZenitEventName.Click;
    payload: Payload<ClickContext>;
    version: Version;
}

export interface ClickContext {
    /** Indicates the type of click the user is performing */
    action: ZenitClickAction;
    /**  Code that identifies the view/image that is presented to the user when visualizing certain product(s). The value corresponds an id associated to a different type of image/view of the product, It can be found in the extraInfo of the xmedia at the color level. */
    assetId: string;
    /** Brandcode associated with the selected item [Bershka: 4, Lefties: 8, MassimoDutti: 11, Oysho: 7, Pull&Bear: 2, Stradivarius: 6, Uterqüe: 18, Zara: 1, 16, ZaraHome: 14] */
    brandId: 11;
    /** Numeric identifier of a category */
    categoryId: number | null;
    /** Alternative identifier of a category-id for those brands which cannot use/retrieve the category-id */
    categoryURL: string | null;
    /** Unique identifier of the product entry in a category */
    catentryId: number;
    /** Locale style ISO-639 Language Code followed by ISO-3166 Country Code, examples: es_ES, es_MX */
    displayLanguage: string;
    /** Metadata of the different active experimentation providers present along users navigation */
    experiments: ZenitExperiments;
    isRecommended: boolean;
    /**  Which element of the user interface was used to add the item to the cart. Must be one of the enum list */
    list: ZenitList;
    /** The position on the list of the element added to cart (only when adding from list) */
    listPosition: number | null;
    /** Type of page that user from which the product is added. Must be one of the list */
    pageType: ZenitPageType;
    /** The Partnumber uniquely identifies any element in the catalog. Must have the format as in the next example: "C01165402712000-V2023". NOTE: If value cannot be sent use a code value of -1' */
    partnumber: string;
    /** Personalization-related information */
    personalization: ZenitPersonalizationParam;
    quantity: number;
    recommender: string;
    /** Section that user is accessing. Must be one of the enum list */
    section: Section | null;
    /** SKU identifier including associated campaign. This is MOCACOTA (MOdelo, CAlidad, COlor, TAlla) */
    sku: string;
    /** Ecommerce Online Store Id - References OnlineStore entity */
    storeId: number;
    /** Properties related with the suggestions offered in the search assistant */
    suggestions: any; // NOTE: Funcionalidad actualmente no implementada en el buscador de MD
    /** Type of template used to display items on grid (In ZA corresponds with the GA dimension -> pr1cd198) */
    templateType: string;
    /** Associated section to the menu that the user interacts with IMPORTANT Must be one of the enumerated list */
    universe: ZenitUniverse;
    /** Code that identifies the view/image that is presented to the user when visualizing certain product(s) The value corresponds to different identifiers (p, e0, a1, ult, ...) associated to a different type of image/view of the product */
    viewOrigin: string;
    /** Zoom level applied to the displayed items grid */
    zoomLevel: ZenitZoomLevel;
}

export enum ZenitClickAction {
    'add-color-filter' = 'add-color-filter',
    'add-price-filter' = 'add-price-filter',
    'add-qty' = 'add-qty',
    'add-size-filter' = 'add-size-filter',
    'add-to-cart' = 'add-to-cart',
    'add-to-wishlist' = 'add-to-wishlist',
    'click-banner-home' = 'click-banner-home',
    'close' = 'close',
    'home' = 'home',
    'init-search' = 'init-search',
    'menu-close-subsection' = 'menu-close-subsection',
    'menu-open-category' = 'menu-open-category',
    'menu-open-subsection1' = 'menu-open-subsection1',
    'menu-open-universe' = 'menu-open-universe',
    'menu-open' = 'menu-open',
    'open-qr' = 'open-qr',
    'remove-all-filter' = 'remove-all-filter',
    'remove-filter' = 'remove-filter',
    'remove-from-cart' = 'remove-from-cart',
    'remove-from-wishlist' = 'remove-from-wishlist',
    'remove-qty' = 'remove-qty',
    'select-color' = 'select-color',
    'select-item' = 'select-item',
    'select-size-recommended' = 'select-size-recommended',
    'select-size' = 'select-size',
    'share' = 'share',
    'swipe-home' = 'swipe-home',
    'swipe-image' = 'swipe-image',
    'swipe-pdp' = 'swipe-pdp',
    'top-sibling-category' = 'top-sibling-category',
}
